module.exports = __webpack_public_path__ + "static/media/snapshot1a.2539e252.png";